import { OwcListItem, OwcCheckbox, OwcList, OwcTypography } from '@one/react';
import React from 'react';
import '../../styles.scss';
import DelayedTooltip from './DelayedTooltip';

const emptySublist = "No sublist"

/**
 * Renders a reference list as as selection list.
 *
 * @copyright Roche 2024
 * @author Geoffroy Maillol
 */
class ReferenceListSelector extends React.Component {
  /**
   * Constructor 
   * 
   * @param props The properties passed
   */
  constructor(props) {
      super(props);
      // Initialise the sublist list to be expanded 
      const sublistExpandedState = Object.fromEntries(
        this.getUniqueSublists().map(sublist => [sublist, true]));
      this.state = {
        showDeprecated: props.displayDeprecatedItems,
        sublistExpandedState: sublistExpandedState,
      };
  }

  getUniqueSublists() {
    return [...new Set(this.props.refListData.flatMap(item => item.sublist)), emptySublist];
  }

  handleExpandedChange(subListItem, newValue) {
    const sublistExpandedState = this.state.sublistExpandedState;
    sublistExpandedState[subListItem] = newValue;
    this.setState({sublistExpandedState: sublistExpandedState});
  }

  sublistIsEmpty(item, subListItem) {
    return subListItem === emptySublist && (!Array.isArray(item.sublist) || item.sublist.length === 0);
  }

  itemInSublists(item, subListItem) {
    return item.sublist && item.sublist.includes(subListItem);
  }

  renderItem(item) {
    if (item.isActive || (!item.isActive && this.state.showDeprecated)) {
      return (
        <>
        <OwcListItem key={item.refListId} id={item.refListId}
            size={this.props.size}
            value={item.refListId} >
          {item.description}{item.isActive? "" : " (Deprecated)"}
        </OwcListItem>
        {(this.props.listItemTooltips===true && item.comment!==null && item.comment.length > 0)?
         <DelayedTooltip key={`${item.refListId}tooltip`} id={`${item.refListId}tooltip`} anchor={item.refListId} offset={[0,-1]}>
          {item.comment}
         </DelayedTooltip>
        :
         <></>
        }
        </>
      );
    }
  }

  aggregateBySublist() {
    return this.getUniqueSublists().map(subListItem =>
      <OwcListItem key={"SublistListItem" + subListItem} expanded={this.state.sublistExpandedState[subListItem]}
          onExpandedChange={(ev) => this.handleExpandedChange(subListItem, ev.detail)}>
        {subListItem}
        <OwcList key={"ItemInSubList" + subListItem} slot="children">
          {this.props.refListData
            .filter(item => this.itemInSublists(item, subListItem) || this.sublistIsEmpty(item, subListItem))
            .map(item => this.renderItem(item))}
        </OwcList>
      </OwcListItem>
    );
  }

  /**
   * Renders the controls
   * @returns The JSX of the controls
   */
  render() {
    if (this.props.refListData) {
      return (
        <div style={{ display:"flex", flexDirection:"column" }}>
          {this.props.title.length>0?
          <OwcTypography variant="title6">
            {this.props.title}
          </OwcTypography>
          :
          ""
          }
          {
            this.props.displayDeprecatedToggle === true
            ? <OwcCheckbox onValueChange={(ev) => this.setState({showDeprecated: ev.detail})}>
                Display deprecated items
              </OwcCheckbox>
            : ""
          }
          
          <OwcList multiple showSelectorControl selected={this.props.selectedItems}
              onSelectedChange={(ev) => this.props.onSelectedChange(ev.detail)}>
            {this.props.aggregateSublist
              ? this.aggregateBySublist()
              : this.props.refListData.map(item => this.renderItem(item))
            }
          </OwcList>
        </div>
      );
    }
  }
}

ReferenceListSelector.defaultProps = {
  size: 'small',
  displayDeprecatedToggle: false,
  displayDeprecatedItems: false,
  title: "",
  aggregateSublist: false,
  listItemTooltips: true
}

export default ReferenceListSelector
